import React, { useState } from "react";
import AdDashborad from "./AdDashborad";

import Footer from "../../Common/Footer";
import "./styles.css"
import CreateCampaign from "./CreateCampaign";


import {  useRef } from "react";
import Header from "../../Common/Header";


import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";
import AdsReport from "./AdsReport";
import BillingPayment from "./BillingPayment";
import AdsHelp from "./AdsHelp";
import BoostCredit from "./BoostCredit";



const tabs = [
  { id: "campaigns", label: "Campaigns", icon: "ri-play-circle-line" },
  { id: "create", label: "Create", icon: "ri-add-circle-line text-sm" },
  { id: "boost", label: "Boost Credits", icon: "ri-coins-line text-sm" },
  { id: "reports", label: "Ads Reports", icon: "ri-bar-chart-box-line" },
  { id: "billing", label: "Billing", icon: "ri-wallet-3-line" },
  { id: "support", label: "Help", icon: "ri-customer-service-2-line" }
];

export default function AdSidebar() {
  const [activeTab, setActiveTab] = useState("campaigns");

  const renderContent = () => {
    switch (activeTab) {
      case "campaigns":
        return (
          <div className="content">
            <AdDashborad />
          </div>
        );

      case "create":
        return (
          <div className="content">
           <CreateCampaign />
          </div>
        );

         case "boost":
        return (
          <div className="content">
           <BoostCredit />
          </div>
        );


      case "reports":
        return (
          <div className="content">
          <AdsReport />
          </div>
        );

      case "billing":
        return (
          <div className="content">
          <BillingPayment />
          </div>
        );

      case "support":
        return (
          <div className="content">
          <AdsHelp />
          {/* <h3>Support</h3> */}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <Header />
        <div className="content-wrapper">
        <section>
          <div className="header-wrapperr pb-30" style={{background:'#fff'}}>
           <div className="container">
            <div className="header-content">
              <h1 className="header-title">LandPanda Ads</h1>
              <p className="header-subtitle">
                Boost your property visibility and get more leads.
              </p>
            </div>
          </div>
          </div>
        </section>
        <section className="property-wrap ">
          <div className="container">
            <div className="app">

              {/* Sidebar for Desktop */}
              <div className="sidebarr">
                <div className="nav-title">NAVIGATION</div>

                {tabs.map(tab => (
                  <div
                    key={tab.id}
                    className={`menu ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.id)}
                  >

                    <div className="w-7 h-7 flex items-center justify-center rounded-lg flex-shrink-0 iconn">
                    <i className={tab.icon}></i>
                  </div>

                  
                    <span>{tab.label}</span>
                  </div>
                ))}
              </div>

              {/* Top Horizontal Tabs for Mobile/Tablet */}
              <div className="top-tabs">
                {tabs.map(tab => (
                  <div
                    key={tab.id}
                    className={`tab ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                      <i className={tab.icon}></i>
                    <span className="tab-text">{tab.label}</span>
                  </div>
                ))}
              </div>

              {/* Content */}
              <div className="main">{renderContent()}</div>

            </div>
          </div>
      </section>
      </div>
      {/* <Footer /> */}
    </div >
    </>
  );
}